import { Box, Flex } from "@chakra-ui/react";
import { Redirect, Route, Switch, useRoute } from "wouter";

import { TbiSidebar } from "@/components/tbi-sidebar";
import { LoginPage } from "@/pages/login-page";
import { MainPage } from "@/pages/main-page";
import { ReportPage } from "@/pages/report-page";
import { ReportsPage } from "@/pages/reports-page";
import { UsersPage } from "@/pages/users-page";

import { useStatusQuery } from "../queries/query-status";

const REPORT_ROUTE = "/reports/:slug";
export function Routes() {
  const statusResponse = useStatusQuery();
  const [isReportPage] = useRoute(REPORT_ROUTE);

  if (!statusResponse.isSuccess) return null;

  const status = statusResponse.data;

  if (!status.authenticated) {
    return <LoginPage />;
  }

  const { hasWriteAccess, hasAdminAccess } = status;

  return (
    <Flex minH="100vh" w="full" bg={isReportPage ? undefined : "brand.page_bg"}>
      <TbiSidebar />
      <Box flexGrow={1}>
        <Switch>
          <Route path="/users">{hasAdminAccess ? <UsersPage /> : <Redirect to="/reports" />}</Route>
          <Route path="/reports">
            <ReportsPage />
          </Route>
          <Route path={REPORT_ROUTE}>{(params) => <ReportPage slug={params.slug} />}</Route>
          <Route>{hasWriteAccess ? <MainPage /> : <Redirect to="/reports" />}</Route>
        </Switch>
      </Box>
    </Flex>
  );
}
